import { render, staticRenderFns } from "./error-503.vue?vue&type=template&id=68420be2&"
import script from "./error-503.vue?vue&type=script&lang=js&"
export * from "./error-503.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports